import {
    SET_DADOS_USUARIO,
    SET_PERMISSOES,
    SET_FILIAL,
    SET_REGIONAL,
    RESET_STATE, SET_TODAS_REGIONAIS, SET_TODAS_EMPRESAS, SET_EMPRESA
} from '../actionTypes';

export const resetState = () => {
    return { type: RESET_STATE };
};

export const setDadosUsuario = (dadosUsuario) => {
    return {
        type: SET_DADOS_USUARIO,
        dadosUsuario
    }
};

export const setPermissoes = (permissoes) => {
    return {
        type: SET_PERMISSOES,
        permissoes
    }
};

export const setEmpresa = (empresa) => {
    return {
        type: SET_EMPRESA,
        empresa
    }
};

export const setFilial = (filial) => {
    return {
        type: SET_FILIAL,
        filial
    }
};

export const setRegional = (regional) => {
    return {
        type: SET_REGIONAL,
        regional
    }
};

export const setTodasRegionais = (todasRegionais) => {
    return {
        type: SET_TODAS_REGIONAIS,
        todasRegionais
    }
};


export const setTodasEmpresas = (todasEmpresas) => {
    return {
        type: SET_TODAS_EMPRESAS,
        todasEmpresas
    }
};